import { Controller } from "@hotwired/stimulus"

class Footer extends Controller {
  height() {
    return this.element.getBoundingClientRect().height
  }
}

export { Footer }
